import { disabled, hidden }            from '../../button/button.class.scss'
import { autospin_interface_open }     from '../../../sass/button/autospin.class.scss'
import { Interface }                   from '../interface.class'
import { AutospinMinus }               from './button/autospinInterface.button.minus.class'
import { AutospinPlus }                from './button/autospinInterface.button.plus.class'
import { AutospinInterfaceSetting }    from './setting/autospinInterface.setting.class'
import { SPIN_STATE }                  from '../../../constants/spinState/spin-state.constant'
import { arch }                        from '../../../sass/button/arch/button.arch.class.scss'
import { Click }                       from '../../click/click.class'

//Mobile autospin button data URI's
import * as autospinStartMb from '../../../assets/mobile/mb-pt-autsopin-start.svg'
import * as autospinSpinMb  from '../../../assets/mobile/mb-pt-autsopin-spin.svg'
import * as autospinStopMb  from '../../../assets/mobile/mb-pt-autsopin-stop.svg'

//Mobile close button data URI
import * as close from '../../../assets/mobile/mb-pt-btn-close.svg'

/**
 * @file Defines the {@link AutospinInterface} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Class for handling autospin interface
  * @extends Interface
  */
  export class AutospinInterface extends Interface {
    
    /**
     * Reference to minus button
     * @memberof AutospinInterface
     * @protected
     * @instance
     * @type {AutospinMinus}
     */
    _minus

    /**
     * Reference to plus button
     * @memberof AutospinInterface
     * @protected
     * @instance
     * @type {AutospinPlus}
     */
    _plus

    /**
     * Object storing all autoplay settings
     * @memberof AutospinInterface
     * @protected
     * @instance
     * @type {object}
     */
    _settings

    /** Initialise autospin interface */ 
     constructor() {

        super('autospin') //Call parent constructor
        this.render()     //Render autospin interface

        this.topButton('autospin') //Create close button

        this._minus = new AutospinMinus(), //Add minus button
        this._plus  = new AutospinPlus()   //Add plus button

        this._settings = {

            /** Whether to stop on any win */
            onAnyWin: new AutospinInterfaceSetting('on-any-win', 'StopOnAnyWin', 0, null, null, null, null, true),
        
            /** Whether to stop on a single win of X amount */
            onSingleWin: new AutospinInterfaceSetting('on-single-win', 'StopOnSingleWin', 1, 'autoPlayWinLimit', 'setSingleWinThreshold', null, null, true),

            /** Whether to stop if cash increases by X amount */
            cashIncreasesBy: new AutospinInterfaceSetting('if-cash-increase', 'StopOnWin', 2, 'autoPlayCashLimit', 'setWinThreshold', null, null, true),

            /** Whether to stop if cash decreases by X amount */
            cashDecreasesBy: new AutospinInterfaceSetting('if-cash-decrease', 'StopOnLose', 3, 'autoPlayCashDownLimit', 'setLoseThreshold', loginVars.getRegParams().jurisdiction === 'uk', true, true),

            /** Whether to stop when entering a feature */
            onFeature: new AutospinInterfaceSetting('on-feature', 'StopOnFeature', 4, null, null, null, null, true)
        
        }

        let autoPage = document.getElementById('autoPage') //Store iron dog autoplay settings node

        //Loop through autospin settings
        for (let s in this._settings) {

            let setting = this._settings[s] //Store setting
            let index   = setting.index     //Store setting index

            //On setting change
            setting.node.addEventListener('change', () => {

                //If setting must be always on
                if (setting.checked) {
                    setting.node.checked = true //Make setting permanently on/checked
                } 
                
                //Setting is toggleable
                else {

                    let c     = autoPage.querySelectorAll('input[type="checkbox"]')[index] //Retrieve checkbox in autoplay settings
                    c.checked = setting.node.checked                                       //Check/uncheck
                    autoPlayManager_[`toggle${setting.function}`](c.checked)               //Execute iron dog autoplay settings function

                }

            })

        }

        let curSym = document.getElementsByClassName('cur-sym')                              //Retrieve labels to store currency symbol
        Array.from(curSym).map(v_ => v_.innerHTML = balanceManager_.geBalanceObj().currency) //Set currency symbol in label

     }

     /** Get show */     get show()     { return this._show }
     /** Get settings */ get settings() { return this._settings }

    /** Set show */ 
    set show(v_) {

        super.show = v_ //Set show flag

        //If interface showing
        if (this.show) {
            
            let text       = document.getElementById('autospin-amount') //Retrieve autospin amount node
            text.innerHTML = window.newUI.autospin().text               //Display current autospin amount in text

            window.newUI.autospin().textElem.classList.add(hidden) //Hide autospin button text
            
            //For each setting
            for (let s in this._settings) {

                let setting          = this._settings[s]                            //Store setting
                setting.node.checked = autoPlayManager_[`get${setting.function}`]() //Check/uncheck checkbox depending on setting

            }


            //Build array containing all autospin interface buttons
            let arr = [

                this._minus,
                this._plus

            ]

            //For each button in autospin interface
            arr.forEach((b_) => {
                
                //If click handler not added for button
                if (!b_.added) {
                    b_.add() //Add click handler to button
                }

            })

            //For each button
            window.newUI.buttons.forEach((b_) => {

                //If interface is showing
                if (this.show) {

                    //If autospin button
                    if (b_.id === 'autospin') {
                        b_.elem.classList.add(autospin_interface_open) //Make autospin button inline with minus button
                    }

                    //If menu button
                    if (b_.id === 'menu') {

                        b_.state = 'CLOSE' //Set to close state
                        b_.elem.classList.add(autospin_interface_open) //Make bet button inline with minus button

                    }

                    //If button is not autospin or menu
                    if (b_.id !== 'autospin' && b_.id !== 'menu') {
                        b_.visible = false //Hide button
                    }
                    
                    b_.id === 'autospin' || b_.id === 'menu' ? b_.enable = true : b_.enable = false //Disable all buttons except autospin & sound button

                    //If button has text and isn't autospin button
                    if (b_.id !== 'autospin' && b_.text !== '') {
                        document.getElementById('bet-text').classList.add(disabled) //Add disabled styling to text
                    }

                }

            })

        }

        //Interface isn't showing
        else {

            document.getElementById('bet-text').classList.remove(disabled) //Remove disabled styling from button text
            document.getElementById(arch).classList.remove(hidden)         //Make arch visible (if portrait)

            buttonManager_.applyState('NH') //Apply iron dog default state

            window.newUI.autospin().textElem.classList.remove(hidden)              //Hide autospin button text
            window.newUI.autospin().elem.classList.remove(autospin_interface_open) //Apply default autospin button styling

            //Apply default menu button styling
            window.newUI.menu().state = 'MENU'
            window.newUI.menu().elem.classList.remove(autospin_interface_open)

            //On game spin
            SPIN_STATE.onSpin.add(v_ => {

                //If spinning
                if (v_) {

                    //For each button
                    window.newUI.buttons.forEach(b_ => {
                        
                        //If spin button
                        if (b_.id === 'spin') {

                            b_.enable  = false //Disable spin button
                            b_.visible = true  //Make spin button visible

                        }

                        else {

                            b_.enable  = true //Enable button
                            b_.visible = true //Make button visible

                        }

                    })

                }

            })

        }

        this.render() //Render interface

    }

    /**
     * Click handler for closing autospin interface
     * @param {object} this_ - Reference to class's scope
     */
    click(this_) {

        let _this = this_  //Store reference to scope
        super.click(_this) //Call parent click method
        _this.show = false //Hide interface

    }

    /**
     * Adds top button to interface
     * @param {string} id_ - ID of interface to add close button to
     */
    topButton(id_) {

        let arr = [ autospinStartMb, autospinSpinMb, autospinStopMb ] //Array of autoplay button assets

        //For each asset
        arr.forEach(a_ => {

            let elem = new DOMParser().parseFromString(a_, 'text/xml') //Parse SVG string

            //If not spin state
            if (!elem.documentElement.id.includes('spin')) {
                elem.documentElement.classList.add('hidden') //Hide asset
            }

            let btn = document.getElementById(`${id_}-play`)
            btn.appendChild(elem.documentElement) //Add to button

            new Click(btn, this.autoplayClick, this) //Add click handler

        })

        super.topButton(id_)    //Add close button

    }

    /**
     * Click handler for closing autospin interface
     * @param {object} this_ - Reference to class's scope
     */
    autoplayClick(this_) {

        let _this = this_         //Store reference to scope
        framework.checkAutoPlay() //Check whether autoplay can begin

    }
 
  }